import React from 'react';


const CloseIcon = ({ theme }) => {
  return (
    <div style={styles.container}>
      {/* <IosClose style={styles.closeIcon}/> */}
      <svg xmlns="http://www.w3.org/2000/svg" style={styles.closeIcon} fill="rgba(60, 60, 67, 0.6)" width="21px" height="21px" viewBox="0 0 512 512"><path d="M289.94 256l95-95A24 24 0 00351 127l-95 95-95-95a24 24 0 00-34 34l95 95-95 95a24 24 0 1034 34l95-95 95 95a24 24 0 0034-34z"/></svg>
    </div>
  );
};

const styles = {
  container: {
    display: 'flex',
    flexShrink: 0,
    justifyContent: 'center',
    alignItems: 'center',
    width: 30,                                                      // iOS 18 | Action Sheet
    height: 30,                                                     // iOS 18 | Action Sheet
    borderRadius: 50,
    backgroundColor: 'rgba(120, 120, 128, 0.12)',                   // iOS 18 | Action Sheet
  },
};

export default CloseIcon;
